import { change } from 'redux-form';
import { createRemoveAction } from '@paysera/redux-state-restore';
import { FORM_NAME } from '%paysera_simple_event/js/event/component/Form/config/constants';
import { resetWorkflow, resetModels, selectHallEntityId } from '%paysera_seat_selection/js/seatSelection/redux';
import ormStorageConfig from '%paysera_seat_selection/js/seatSelection/redux/component/orm/config/storage';

const remove = createRemoveAction(ormStorageConfig);

function deleteSeatSelection() {
    return (dispatch, getState) => {
        dispatch(remove(selectHallEntityId(getState())));

        dispatch(resetWorkflow());
        dispatch(resetModels());

        dispatch(change(FORM_NAME, 'hall_hash', null));
        dispatch(change(FORM_NAME, 'seat_selection_enabled', false));
    };
}

export default deleteSeatSelection;
